import { render } from "./attachmentComponent.vue?vue&type=template&id=5ec3ac56&scoped=true"
import script from "./attachmentComponent.vue?vue&type=script&lang=js"
export * from "./attachmentComponent.vue?vue&type=script&lang=js"

import "./attachmentComponent.vue?vue&type=style&index=0&id=5ec3ac56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec3ac56"]])

export default __exports__